$('.polysearch-link').one('click', function (event) {
  event.preventDefault();
  const $this = $(this);
  const $form = $this.closest('form');
  const action = $this.data('action');
  const $input = $form.find('input.q');
  const added = $this.data('added-elements');
  const q = $this.data('q');

  if (added) {
    let appendedElements = '';

    Object.entries(added).forEach(([key, value]) => {
      appendedElements += `<input type="hidden" name="${key}" value="${value}" />`;
    });
    $form.append(appendedElements);
  }

  $input.attr('name', q);

  $form.find('input.default')
    .attr('disabled', 'disabled')
    .end()
    .attr('action', action)
    .submit();
});
